const style = {
  updateEmailForm__notificationMessage: {
    marginBottom: '10px',
  },
};

export default style;
